import "./switcher.css";

interface SwitcherProps {
  options: string[]; // Array of button labels
  current: string; // Current active option
  onChange: (selected: string) => void; // Callback function when an option is clicked
}

const Switcher: React.FC<SwitcherProps> = ({ options, current, onChange }) => {
  return (
    <div className="switcher-c">
      {options.map((option, index) => (
        <div
          key={index}
          className={`switcher-button ${
            current === option ? "switcher-button-active" : ""
          }`}
          onClick={() => onChange(option)}
        >
          {option}
        </div>
      ))}
    </div>
  );
};

export default Switcher;
